export const GET_VENDOR_DOCUMENTS_REQUEST = "get_vendor_documents_request";
export const GET_VENDOR_DOCUMENTS_SUCCESS = "get_vendor_documents_success";
export const GET_VENDOR_DOCUMENTS_FAILURE = "get_vendor_documents_failure";

export const UPLOAD_VENDOR_DOCUMENT_REQUEST = "upload_vendor_document_request";
export const UPLOAD_VENDOR_DOCUMENT_SUCCESS = "upload_vendor_document_success";
export const UPLOAD_VENDOR_DOCUMENT_FAILURE = "upload_vendor_document_failure";

export const DELETE_VENDOR_DOCUMENT_REQUEST = "delete_vendor_document_request";
export const DELETE_VENDOR_DOCUMENT_SUCCESS = "delete_vendor_document_success";
export const DELETE_VENDOR_DOCUMENT_FAILURE = "delete_vendor_document_failure";

export const GET_SHARE_TARGETS_REQUEST = "get_share_targets_request";
export const GET_SHARE_TARGETS_SUCCESS = "get_share_targets_success";
export const GET_SHARE_TARGETS_FAILURE = "get_share_targets_failure";

export const SHARE_VENDOR_DOCUMENT_REQUEST = "share_vendor_document_request";
export const SHARE_VENDOR_DOCUMENT_SUCCESS = "share_vendor_document_success";
export const SHARE_VENDOR_DOCUMENT_FAILURE = "share_vendor_document_failure";

export const UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST =
  "update_vendor_document_status_request";
export const UPDATE_VENDOR_DOCUMENT_STATUS_SUCCESS =
  "update_vendor_document_status_success";
export const UPDATE_VENDOR_DOCUMENT_STATUS_FAILURE =
  "update_vendor_document_status_failure";
